export default "__VITE_ASSET__CeoI1iag__"